<template>
  <div id="app">
    <div class="cookieWrapper">
      <div class="buttons">
        <button class="rebirth" @click="rebirth()">Rebirth</button>
      </div>
      <p class="points" v-text="getPoints()"></p>
      <p>Rebirths: {{ rebirths }}</p>
      <a onclick=";">
        <img
          src="./assets/cupcake.svg"
          @click="addPoint()"
          alt="cupcake"
          class="cookie"
        />
      </a>
    </div>
    <Shop :items="items"></Shop>
    <ScrollButton :action="switchScreen" v-bind:degs="arrowDegs"></ScrollButton>
    <div class="rat" v-bind:style="ratStyle" @click="points *= 1.1">
      <img src="https://i.imgur.com/xBJNqwX.gif" alt="rat" draggable="false" />
    </div>
  </div>
</template>

<script>
import Shop from "./components/Shop.vue";
import ScrollButton from "./components/ScrollButton.vue";
import items from "./items.js";
import numfor from "./numfor.js";

export default {
  name: "App",
  data() {
    let points = localStorage.getItem("points")
      ? Number(localStorage.getItem("points"))
      : 0;

    let itemdata = localStorage.getItem("itemdata")
      ? JSON.parse(localStorage.getItem("itemdata"))
      : {};

    let rebirths = localStorage.getItem("rebirths")
      ? Number(localStorage.getItem("rebirths"))
      : 0;

    // for (let iditem of Object.keys(itemdata)) {
    //   items[items.findIndex((e) => e.name === iditem)].amount =
    //     itemdata[iditem];
    // }
    setTimeout(this.boot, 200);

    return {
      items,
      itemdata,
      points,
      arrowDegs: 0,
      rebirths,
      ratStyle: { top: "10vh" },
    };
  },
  components: {
    Shop,
    ScrollButton,
  },
  methods: {
    save() {
      localStorage.setItem("points", Math.floor(this.points));
      localStorage.setItem("rebirths", Math.floor(this.rebirths));
      localStorage.setItem("itemdata", JSON.stringify(this.itemdata));
      this.updateAmounts();

      // console.log(
      //   "%cSaved at " + new Date().toTimeString().split(" ")[0],
      //   "color: green"
      // );
    },
    async rebirth() {
      let rebirthLimit =
        100_000_000_000_000_000_000_000_000 * (Math.pow(2, this.rebirths) / 2);
      let swal = window.swal || {};
      if (this.points < rebirthLimit) {
        return swal(
          "Oops",
          "You don't have " + numfor(rebirthLimit) + " cupcakes yet",
          "error"
        );
      }
      let swalRes = await swal({
        title: "Are you sure?",
        text:
          "Rebirthing will remove all of your items and cupcakes but will earn you more cupcakes after the rebirth.",
        icon: "warning",
        buttons: true,
        dangerMode: true,
      });
      if (swalRes) {
        this.itemdata = {};
        this.points = 0;
        this.rebirths++;
        this.save();
      }
    },
    updateAmounts() {
      for (let iindex in this.items) {
        this.items[iindex].amount = this.itemdata[this.items[iindex].name] || 0;
        this.items[iindex].cost = Math.floor(
          Math.pow(this.items[iindex].amount + 1, 1.4) *
            this.items[iindex].ogcost *
            (Math.pow(2, this.rebirths) / 2)
        );
      }
    },
    addPoint() {
      this.points += 1 * Math.pow(2, this.rebirths + 1);
      this.save();
    },
    getPoints() {
      return numfor(this.points);
      // const cakeformater = new Intl.NumberFormat("sv-SE");
      // return cakeformater.format(Math.floor(this.points));
    },
    buyItem(iname) {
      let item = this.items.find((e) => e.name === iname);
      if (!this.items.find((e) => e.name === iname)) return;
      this.itemdata[iname] = this.itemdata[iname] ? this.itemdata[iname] : 0;
      if (item.cost <= this.points) {
        this.points -= item.cost;
        this.itemdata[iname]++;
      }
      this.save();
    },
    reset() {
      this.itemdata = {};
      this.points = 0;
      this.items = items;
      this.save();
      location.reload();
    },
    update() {
      let totalAdd = 0;
      for (let item of this.items) {
        totalAdd += (this.itemdata[item.name] || 0) * item.cps;
      }
      this.points += (totalAdd / 20) * Math.pow(2, this.rebirths + 1);
      this.save();
    },
    boot() {
      this.updateAmounts();
      window.updator = setInterval(this.update, 50);
      window.ratRunner = setInterval(
        (() => {
          if (Math.random() > 0.5) {
            document.querySelector(".rat").classList.add("run");
            let randomHeight = Math.floor(Math.random() * 85);
            this.ratStyle = { top: String(randomHeight + "vh") };

            setTimeout(() => {
              document.querySelector(".rat").classList.remove("run");
            }, 2 * 1000);
          }
        }).bind(this),
        20 * 1000
      );

      window.cc = this;
      this.numfor = numfor;
    },
    switchScreen() {
      if (window.scrollX != 0) {
        window.scrollTo({
          behavior: "smooth",
          left: 0,
        });
        this.arrowDegs = 0;
      } else {
        window.scrollTo({
          behavior: "smooth",
          left: window.innerWidth,
        });
        this.arrowDegs = 180;
      }
    },
  },
  beforeDestroy() {
    clearInterval(window.updator);
    clearInterval(window.ratRunner);
  },
};
</script>

<style>
@import url("https://fonts.googleapis.com/css2?family=Montserrat&family=Roboto&display=swap");
body {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  min-width: 100%;
  padding: 0px;
  margin: 0px;
  box-sizing: border-box;

  font-family: "Roboto", sans-serif;

  overflow: hidden;
  scroll-behavior: smooth;

  touch-action: none;
}
#app {
  display: flex;
  height: 100vh;
}
.cookieWrapper {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  flex-grow: 1;

  background: rgb(44, 233, 255);
  background: linear-gradient(
    0deg,
    rgba(44, 233, 255, 1) 0%,
    rgba(0, 104, 255, 1) 100%
  );
}
.cookie {
  width: 30vw;
  height: 30vw;

  filter: drop-shadow(0 0 1rem rgb(255, 255, 255));

  transition: transform ease-in-out 0.2s, width ease-in-out 0.2s,
    height ease-in-out 0.2s;
}
.cookie:hover {
  width: 31vw;
  height: 31vw;
  transform: rotate(1deg);
}
.cookie:active {
  width: 29vw;
  height: 29vw;
  transform: rotate(-1deg);
}
p.points {
  font-size: 2rem;
  font-weight: 800;
  font-family: "Montserrat", sans-serif;
  padding: 0;
  margin: 0;
}
.buttons {
  position: fixed;
  left: 0px;
  top: 0px;
  padding: 0.75rem;
}
.buttons button {
  margin-right: 0.25rem;
  font-size: 1.2rem;
  background-color: white;
  color: black;
  font-weight: 600;
  border: solid 1px black;
  border-radius: 0.2rem;
  outline: none;
}
.buttons button:active {
  background-color: lightgray;
}

.rat {
  position: fixed;
  left: -15rem;
}
.rat img {
  width: 15rem;
  height: auto;
}
.rat.run {
  animation: run 2s linear;
}
@keyframes run {
  from {
    left: -15rem;
  }
  to {
    left: 100vw;
  }
}

.scrollButton {
  position: fixed;
  top: 0px;
  right: 0px;

  opacity: 0;
  pointer-events: none;
}

@media screen and (orientation: portrait) {
  .shop,
  .cookieWrapper {
    width: 100vw;
    height: 100vh;
    scroll-snap-align: start;
  }
  #app {
    width: 200%;
    height: 100%;

    scroll-snap-type: x mandatory;
  }
  /* .cookieWrapper {
    scroll-snap-align: start;
  }
  .shop {
    scroll-snap-align: start;
  } */
  .scrollButton {
    z-index: 10;

    opacity: 1;
    pointer-events: initial;
  }

  .cookie {
    width: 80vw;
    height: 80vw;
  }
  .cookie:hover {
    width: 81vw;
    height: 81vw;
  }
  .cookie:active {
    width: 79vw;
    height: 79vw;
  }
}
</style>

<style scoped>
a {
  background-color: transparent;
  border: none;
  outline: none;

  touch-action: none;
}
</style>
